document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.review-tab-slider-section');

  sections.forEach(section => {

    const ReviewFilter = {
      init() {
        this.section = section;
        this.trackWrapper = section.querySelector('.reviews-marquee-wrapper');
        this.carouselWrapper = section.querySelector('.reviews-mobile-slider ul') || null;

        if (!this.trackWrapper) return;
        this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

        this.allCards = Array.from(
          this.trackWrapper.querySelectorAll('.review-card')
        ).map(card => card.cloneNode(true));

        this.allCarouselCards = this.carouselWrapper
          ? Array.from(this.carouselWrapper.querySelectorAll('.review-card')).map(card => card.cloneNode(true))
          : [];

        const alleButton = section.querySelector('.category-filters [data-category="all"]');
        if (alleButton) {
          alleButton.classList.add('active');
          alleButton.classList.remove('badge');
          alleButton.classList.add('badge-invert');
        }

        this.setupFilters();
        this.filterReviews('all');
      },

      setupFilters() {
        const filterButtons = this.section.querySelectorAll('.category-filters button');

        filterButtons.forEach(button => {
          button.addEventListener('click', () => {

            filterButtons.forEach(btn => {
              btn.classList.remove('active');
              btn.classList.remove('badge-invert');
              btn.classList.add('badge');
            });

            button.classList.add('active');
            button.classList.remove('badge');
            button.classList.add('badge-invert');

            const category = button.dataset.category;
            this.filterReviews(category);
          });
        });
      },

      filterReviews(category) {

        const visibleCards = this.allCards.filter(card => {
          const categories = (card.dataset.categories || '').split(' ');
          return category === 'all' || categories.includes(category);
        });

        if (this.isDesktop) {
          ReviewMarquee.rebuild(this.section, visibleCards);
        }

        if (this.carouselWrapper) {
          const visibleCarouselCards = this.allCarouselCards.filter(card => {
            const categories = (card.dataset.categories || '').split(' ');
            return category === 'all' || categories.includes(category);
          });

          ReviewCarousel.rebuild(this.section, visibleCarouselCards);
        }
      }
    };

    const ReviewMarquee = {
      rebuild(section, cards) {
        const wrapper = section.querySelector('.reviews-marquee-wrapper');
        if (!wrapper) return;

        wrapper.innerHTML = '';

        if (cards.length === 0) {
          const empty = document.createElement('div');
          empty.className = 'no-reviews';
          empty.textContent = 'Geen reviews beschikbaar voor deze categorie.';
          empty.style.padding = '1rem';
          wrapper.appendChild(empty);
          return;
        }

        const track = document.createElement('div');
        track.classList.add('reviews-marquee-track', 'js-marquee-track');

        cards.forEach(card => {
          track.appendChild(card.cloneNode(true));
        });

        const cloneTrack = track.cloneNode(true);
        cloneTrack.classList.remove('js-marquee-track');
        cloneTrack.classList.add('reviews-marquee-clone');

        wrapper.appendChild(track);
        wrapper.appendChild(cloneTrack);

        const cardHeight = track.querySelector('.review-card')?.offsetHeight || 100;
        wrapper.style.height = `${cardHeight}px`;

        this.animate(wrapper, track, cloneTrack);
      },

      animate(wrapper, track, clone) {
        let position = 0;
        const speed = 0.7;
        let animationId = null;
        let paused = true;
        let isVisible = false;

        const step = () => {
          if (paused) return;

          const width = track.offsetWidth;

          if (width === 0) {
            animationId = requestAnimationFrame(step);
            return;
          }

          position -= speed;

          if (Math.abs(position) >= width) {
            position = 0;
          }

          track.style.transform = `translateX(${position}px)`;
          clone.style.transform = `translateX(${position + width}px)`;

          animationId = requestAnimationFrame(step);
        };

        const start = () => {
          if (!isVisible || (!paused && animationId)) return;
          paused = false;
          animationId = requestAnimationFrame(step);
        };

        const stop = () => {
          paused = true;
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        };

        if (window.matchMedia('(hover: hover)').matches) {
          wrapper.addEventListener('mouseenter', stop);
          wrapper.addEventListener('mouseleave', start);
        } else {
          wrapper.addEventListener('touchstart', stop, { passive: true });
          document.addEventListener('touchend', start);
          document.addEventListener('touchcancel', start);
        }

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              isVisible = entry.isIntersecting;
              if (isVisible) {
                start();
              } else {
                stop();
              }
            });
          }, { rootMargin: '200px 0px' });

          observer.observe(wrapper);
        } else {
          isVisible = true;
          start();
        }
      }
    };

    const ReviewCarousel = {
      rebuild(section, cards) {
        const wrapper = section.querySelector('.reviews-mobile-slider ul');
        if (!wrapper) return;

        wrapper.innerHTML = '';

        if (cards.length === 0) {
          const empty = document.createElement('div');
          empty.className = 'no-reviews';
          empty.textContent = 'Geen reviews beschikbaar voor deze categorie.';
          empty.style.padding = '1rem';
          wrapper.appendChild(empty);
          return;
        }

        cards.forEach(card => {
          const li = document.createElement('li');
          li.className = 'grid__item slider__slide';
          li.appendChild(card);
          wrapper.appendChild(li);
        });
      }
    };

    ReviewFilter.init();

  });

});
